export default __webpack_public_path__ + "static/media/LogoPB.cf154a0c.svg";